module.exports = __webpack_public_path__ + "img/lci-logo.c32e1943d40ae6371865a68aeb609c4d.png";